// Main cashier ดันข้อมูลโต๊ะทั้งก้อนขึ้น cloud ตอนเน็ตกลับมา
// (RTDB tables/tableMeta/live + Firestore table_meta/table_state/live)
//
// ทำไมต้องมี: write ที่ค้างตอน offline ถ้าปิด browser ไปก่อนจะหาย และระหว่างหลุดเครื่องอื่นอาจแก้ cloud ไปแล้ว
// เน็ตกลับมาเลยเขียนทับให้ตรงกับที่ POS คำนวณได้ตอนนี้
//
// จังหวะอื่น: boot = trigger แรกของ mobile.items.plugin, ปุ่ม Sync to Cloud = forceSyncToCloud
// ฟังก์ชันเขียนอยู่ใน composables/useCloudSync.ts

import _ from "lodash";
import { PiniaPluginContext } from "pinia";
import { getDatabase, onValue, ref } from "firebase/database";
import { isCloudSyncReady, syncAllToCloud } from "../composables/useCloudSync";

function CloudSyncPlugin({ store }: PiniaPluginContext) {
  if (store.$id !== "jobs") return;

  // หน่วงให้ compuet/tables_v2 นิ่งก่อน — เน็ตกระพริบหลายรอบก็เขียนครั้งเดียว
  const syncLazy = _.debounce(() => {
    syncAllToCloud().catch((e) => console.warn("[cloudSync] sync ขึ้น cloud ไม่สำเร็จ", e));
  }, 2000);

  // เน็ตกลับมา — ครั้งแรกตอน boot ข้าม (mobile.items.plugin ส่งรอบแรกให้แล้ว)
  // ยังไม่เคยส่งรอบแรกก็ข้าม ไม่งั้น tables ที่ยังว่างจะไปทับของจริงบน cloud
  onValue(ref(getDatabase(), ".info/connected"), (snap) => {
    if (snap.val() === true && isCloudSyncReady()) syncLazy();
  });
}

export default defineNuxtPlugin(({ $pinia }) => {
  $pinia.use(CloudSyncPlugin);
});
